module.exports = __webpack_public_path__ + "static/media/gtmobile_thumbnail.196dea58.png";


//////////////////
// WEBPACK FOOTER
// ./src/work/src/gtmobile_thumbnail.png
// module id = 385
// module chunks = 0